function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiBox from "@mui/material/Box";
const Box = ({
  children,
  ...rest
}) => {
  const {
    sx
  } = {
    ...rest
  };
  return /*#__PURE__*/React.createElement(MuiBox, _extends({}, rest, {
    sx: {
      backgroundColor: theme => theme.palette.background.default,
      ...sx
    }
  }), children);
};
export default Box;
Box.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};